import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AtomicMoveMutationVariables = Types.Exact<{
  input: Types.AtomicMoveMovementOrderInput;
}>;


export type AtomicMoveMutation = { __typename?: 'Mutation', atomicMove: { __typename?: 'MovementOrderPayload', movementOrder?: { __typename?: 'MovementOrderStateData', movementOrderId: string, status: Types.MovementOrderStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreateMovementOrderMutationVariables = Types.Exact<{
  input: Types.CreateMovementOrderInput;
}>;


export type CreateMovementOrderMutation = { __typename?: 'Mutation', createMovementOrder: { __typename?: 'MovementOrderPayload', movementOrder?: { __typename?: 'MovementOrderStateData', movementOrderId: string, status: Types.MovementOrderStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ShipMovementOrderMutationVariables = Types.Exact<{
  input: Types.ShipMovementOrderInput;
}>;


export type ShipMovementOrderMutation = { __typename?: 'Mutation', shipMovementOrder: { __typename?: 'MovementOrderPayload', movementOrder?: { __typename?: 'MovementOrderStateData', movementOrderId: string, status: Types.MovementOrderStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReceiveMovementOrderMutationVariables = Types.Exact<{
  input: Types.ReceiveMovementOrderInput;
}>;


export type ReceiveMovementOrderMutation = { __typename?: 'Mutation', receiveMovementOrder: { __typename?: 'MovementOrderPayload', movementOrder?: { __typename?: 'MovementOrderStateData', movementOrderId: string, status: Types.MovementOrderStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const AtomicMoveDocument = new TypedDocumentString(`
    mutation AtomicMove($input: AtomicMoveMovementOrderInput!) {
  atomicMove(input: $input) {
    movementOrder {
      ...MovementOrderState
    }
    errors {
      code
      message
    }
  }
}
    fragment MovementOrderState on MovementOrderStateData {
  movementOrderId
  status
}`);
export const CreateMovementOrderDocument = new TypedDocumentString(`
    mutation CreateMovementOrder($input: CreateMovementOrderInput!) {
  createMovementOrder(input: $input) {
    movementOrder {
      ...MovementOrderState
    }
    errors {
      code
      message
    }
  }
}
    fragment MovementOrderState on MovementOrderStateData {
  movementOrderId
  status
}`);
export const ShipMovementOrderDocument = new TypedDocumentString(`
    mutation ShipMovementOrder($input: ShipMovementOrderInput!) {
  shipMovementOrder(input: $input) {
    movementOrder {
      ...MovementOrderState
    }
    errors {
      code
      message
    }
  }
}
    fragment MovementOrderState on MovementOrderStateData {
  movementOrderId
  status
}`);
export const ReceiveMovementOrderDocument = new TypedDocumentString(`
    mutation ReceiveMovementOrder($input: ReceiveMovementOrderInput!) {
  receiveMovementOrder(input: $input) {
    movementOrder {
      ...MovementOrderState
    }
    errors {
      code
      message
    }
  }
}
    fragment MovementOrderState on MovementOrderStateData {
  movementOrderId
  status
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AtomicMove: build.mutation<AtomicMoveMutation, AtomicMoveMutationVariables>({
      query: (variables) => ({ document: AtomicMoveDocument, variables })
    }),
    CreateMovementOrder: build.mutation<CreateMovementOrderMutation, CreateMovementOrderMutationVariables>({
      query: (variables) => ({ document: CreateMovementOrderDocument, variables })
    }),
    ShipMovementOrder: build.mutation<ShipMovementOrderMutation, ShipMovementOrderMutationVariables>({
      query: (variables) => ({ document: ShipMovementOrderDocument, variables })
    }),
    ReceiveMovementOrder: build.mutation<ReceiveMovementOrderMutation, ReceiveMovementOrderMutationVariables>({
      query: (variables) => ({ document: ReceiveMovementOrderDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAtomicMoveMutation, useCreateMovementOrderMutation, useShipMovementOrderMutation, useReceiveMovementOrderMutation } = injectedRtkApi;
